import React from 'react';

import { Button, cn } from '@src/components/ui';


const Submit = React.forwardRef((props, ref) => {
  const {
    submitting = false,
    fullWidth = false,
    className,
    children = 'Submit',
    ...restProps
  } = props;

  return (
    <Button
      ref={ref}
      type="submit"
      className={cn(fullWidth && 'w-full', className)}
      loading={submitting}
      {...restProps}
    >
      {children}
    </Button>
  );
});

Submit.displayName = 'Submit';
export default Submit;
